import React, { useEffect, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue, setValue } from "@utils/lodash";
import {
  // adminDeleteSpecificCheckpoint,
  DeleteVendorCheckpoint,
  getCheckpointReleaseVendor,
  vendorCheckpointBulkStatus,
} from "@services/checkpoint.service";
import { useNavigate } from "react-router-dom";
import FilterForm from "@components/common/AddFilter/FilterForm";
import NavigationBar from "@components/NotificationBar/index";
import DeleteModal from "@_common/deleteModal";
import { toast } from "react-toastify";
import PaginationPage from "@components/pagination/pagination";
import SearchHeader from "@components/common/SearchHeader";
import {
  adminGetCountriesListManagement,
  adminGetLegislationManagement,
  adminGetLegislationManagementRule,
  adminGetListManagementStateCategoryList,
  adminGetStatesListManagement,
} from "@services/list-management.service";
import Notfound from "@components/Not-Found";
import Loader from "@components/common/Loader";
// import DatePicker from "react-date-picker";
import moment from "moment";
import { QueryRequestHelper, QueryRequestHelperShowFalse } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import CalenderDropdown from "@_common/CalenderDropdown";
import ScrollableReactTable from "@components/ScrollableDatatable";
import FooterWrapper from "@components/common/FooterWrapper";
import MenuRepositorySvgComponent from "../../../assets/svg-components/left-menu/menurepo";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import CheckpointMasterNotfound from "@components/Page-Not-Found/checkpoint-master-not-found";
import { getSpecificCategoryLawById } from "@_common/global-apis";
import { CellProps } from 'react-table';
import SubmenuArrowDownSvgComponent from "../../../assets/svg-components/left-menu/submenu-arrow-down";
import ModuleFilter from "@components/common/ModuleFilter";


interface ICheckpointActiveProps {}

const ClientVendorCheckpoint: React.FunctionComponent<ICheckpointActiveProps> = (
  props: any
) => {
  let navigate = useNavigate();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setList] = React.useState<[]>([]);
  const [isFilterVisible, setFilterVisibility] = React.useState(false);
  const [filterList] = useState([
    { value: "ACTIVE", label: "Active" },
    { value: "INACTIVE", label: "Inactive" },
  ]);

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
      setDate(new Date());
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      if (params.date) {
        setDate(new Date(params.date));
      } else {
        setDate(new Date());
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();
    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      // status: "active",
      sort_by: params.sort_by,
      country_id: getValue(params, `country_id`, ""),
      state_id: getValue(params, `state_id`, ""),
      category_of_law_id: await getSpecificCategoryLawById(
        getValue(params, `category_of_law_id`, "")
      ),
      legislation_id: getValue(params, `legislation_id`, ""),
      legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
      month: params.date
        ? params.date.split("-")[1]
        : date
        ? moment(date).format("MM")
        : moment(dates).format("MM"),
      year: params.date
        ? params.date.split("-")[0]
        : date
        ? moment(date).format("YYYY")
        : moment(dates).format("YYYY"),
        is_active: params.status 
        ? params.status.toLowerCase() === "active" 
        : true,
    
    };
    let queryRequest = QueryRequestHelperShowFalse(payload);
    try {
      setIsLoading(true);
      let resp = await getCheckpointReleaseVendor(queryRequest);
      if (resp) {
        setList(
          getValue(resp, `data.vendors_checkpoint`, []).map((item: object) => ({
            ...item,
            checkpoint_id: getValue(item, `checkpoint.checkpoint_id`, ""),
            category: getValue(item, `checkpoint.category_of_law.text`, ""),
            location_name: getValue(item, `location.location_name`, ""),
            vendor_name: getValue(item, `vendor.vendor_name`, ""),
            status: getValue(item, `is_active`, false) ? "Active" : "Inactive",
            created_date: moment(getValue(item, `created_at`, "")).format(
              "DD MMM YYYY, hh:mm a"
            ),
            compliance_activity: getValue(
              item,
              `checkpoint.compliance_activity`,
              ""
            ),
          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const handleDeleteFun = (id: string, value: string) => {
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await DeleteVendorCheckpoint({ ids: selectedIDs });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData();
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const handleChangeSortBy = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.sort_by = value;
    props.history.push({
      pathname: window.location.pathname,
      query: params,
    });
  };

  // const handleChangeStatus = (value: string) => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   params.status = value;
  //   props.history.push({
  //     pathname: window.location.pathname,
  //     query: params,
  //   });
  // };


  const handleChangeStatus = (name: string, value: string) => {
    if (value) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: value,
        // page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: "",
        // page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const rowClick = (obj: object) => {
    // console.log(getValue(obj,`original`,''))
    // navigate(`/support/detail/${getValue(obj,`original.id`,'')}`)
  };
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: {
          //   background:  'red',
          //   color: 'black'
        },
      };
    }
    return {};
  };
  const columns = React.useMemo(
    () => [
      {
        Header: "Checkpoint ID",
        accessor: "checkpoint_id",
        width: 140,
      },
      {
        Header: "Task ID",
        accessor: "task_id",
        width: 140,
      },
      // {
      //   Header: "Compliance Activity",
      //   accessor: "compliance_activity",
      //   width: 400,
      // },
      {
        Header: "Activity",
        accessor: "compliance_activity",
        width: 350,
        Cell: ({ row }: CellProps<any>) => {
          const complianceActivity = getValue(
            row.original,
            `compliance_activity`,
            ""
          );
      
          const maxCharCount = 100;
          const [showFullContent, setShowFullContent] = useState(false);
      
          const toggleContent = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
            e.stopPropagation();
            setShowFullContent(!showFullContent);
          };
      
          const truncatedContent = complianceActivity
            ? complianceActivity.slice(0, maxCharCount)
            : "";

          return (
            <div>
              {showFullContent ? complianceActivity : truncatedContent}
              {getValue(complianceActivity, `length`, 0) > maxCharCount && (
                <span onClick={toggleContent}>
                  {showFullContent ? <span style={{color:"#276ef1"}}> View less <span style={{ transform: "rotate(180deg)", display: "inline-block"}}> <SubmenuArrowDownSvgComponent color="#276ef1" /> </span></span> : <span> ... <span style={{color:"#276ef1"}}>View more <SubmenuArrowDownSvgComponent color="#276ef1" /> </span></span>}
                </span>
              )}
            </div>
          );
        }
      },
      // {
      // 	Header: "Checkpoint Name",
      // 	accessor: "legislationName",
      // 	width: 250,
      // },
      {
        Header: "Location",
        accessor: "location_name",
        width: 120,
      },
      {
        Header: "Vendor",
        accessor: "vendor_name",
        width: 100,
      },
      {
        Header: "Added On",
        accessor: "created_date",
        width: 150,
      },
      {
        Header: "Status",
        accessor: "status",
        width: 100,
      },
    ],
    []
  );

  /* -------------------------------------------------------------------------- */
  /*                                  Smart Filters                             */
  /* -------------------------------------------------------------------------- */
  const [request, setRequest] = useState<any>({
    country_id: "101",
    state_id: "",
    category_of_law_id: "",
    legislation_id: "",
    legislation_rule_id: "",
  });
  useEffect(() => {
    getStatesList(request.country_id);
  }, [request.country_id]);

  const [countryList, setCountryList] = useState([]);
  const [states, setStates] = useState([]);

  const [categoryOfLawList, setCategoryOfLawList] = useState([]);
  const [legislationList, setLegislationList] = useState([]);
  const [ruleList, setRuleList] = useState([]);

  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  const reset = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no,
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    getData();
    reset1();
  };
  const reset1 = () => {
    setRequest({
      ...request,
      // country_id: '',
      state_id: "",
      category_of_law_id: "",
      legislation_id: "",
      legislation_rule_id: "",
    });
  };

  const getCountriesList = async () => {
    try {
      let resp = await adminGetCountriesListManagement();
      if (resp) {
        setCountryList(
          getValue(resp, `data.countries`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `name`, ""),
            label: getValue(item, `name`, ""),
          }))
        );
      } else {
      }
    } catch (error) {}
  };

  const getStatesList = async (countryId: number) => {
    try {
      let resp = await adminGetStatesListManagement(countryId);
      if (resp) {
        setStates(
          getValue(resp, `data.states`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `name`, ""),
            label: getValue(item, `name`, ""),
          }))
        );
      } else {
      }
    } catch (error) {}
  };

  const getAlreadyAttachedData = async (state_id: string) => {
    try {
      let resp = await adminGetListManagementStateCategoryList(state_id);
      if (resp) {
        setCategoryOfLawList(
          getValue(resp, `data.stateCategoryOfLaw`, []).map((item: object) => ({
            // ...item,
            id: getValue(item, `category_of_law.id`, ""),
            value: getValue(item, `category_of_law.text`, ""),
            label: getValue(item, `category_of_law.text`, ""),
          }))
        );
      } else {
      }
    } catch (error) {}
  };

  const getLegislationList = async (stateId: string) => {
    try {
      let resp = await adminGetLegislationManagement(stateId);
      if (resp) {
        setLegislationList(
          getValue(resp, `data.legislations`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `legislation_name`, ""),
            label: getValue(item, `legislation_name`, ""),
          }))
        );
      } else {
      }
    } catch (error) {}
  };
  const getLegislationRuleList = async (legislation_id: string) => {
    try {
      let resp = await adminGetLegislationManagementRule(legislation_id);
      if (resp) {
        setRuleList(
          getValue(resp, `data.legislationRules`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `rule_name`, ""),
            label: getValue(item, `rule_name`, ""),
          }))
        );
      } else {
      }
    } catch (error) {}
  };

  const handleChangeSelect = (e: any, type: string) => {
    if (type === "country_id") {
      getStatesList(e.id);
      setStates([]);
      setCategoryOfLawList([]);
      setLegislationList([]);
      setRuleList([]);
      setRequest({
        ...request,
        country_id: e.id,
        state_id: "",
        category_of_law_id: "",
        legislation_id: "",
        legislation_rule_id: "",
      });
    }
    if (type === "state_id") {
      setValue(request, `state_id`, "");
      setRequest({
        ...request,
        // state_id: e.id,
        category_of_law_id: "",
        legislation_id: "",
        legislation_rule_id: "",
      });
      getAlreadyAttachedData(e.id);
      getLegislationList(e.id);
      setCategoryOfLawList([]);
      setLegislationList([]);
      setRuleList([]);
    }
    if (type === "category_of_law_id") {
      setRequest({
        ...request,
        category_of_law_id: e.id,
      });
    }
    if (type === "legislation_id") {
      getLegislationRuleList(e.id);
      setRequest({
        ...request,
        legislation_id: e.id,
        legislation_rule_id: "",
      });
    }

    if (type === "legislation_rule_id") {
      setRequest({
        ...request,
        legislation_rule_id: e.id,
      });
    }
  };

  const handleSubmitSmartFilter = () => {
    if (
      getValue(request, `country_id`, "") &&
      getValue(request, `state_id`, "")
      // && getValue(request, `category_of_law_id`, "") &&
      // getValue(request, `legislation_id`, "") &&
      // getValue(request, `legislation_rule_id`, "")
    ) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload: any = {
        ...params,
        page_no: params.page_no,
        country_id: getValue(request, `country_id`, ""),
        state_id: getValue(request, `state_id`, ""),
        category_of_law_id: getValue(request, `category_of_law_id`, ""),
        legislation_id: getValue(request, `legislation_id`, ""),
        legislation_rule_id: getValue(request, `legislation_rule_id`, ""),
        search_text: getValue(params, `search_text`, ""),
        limit: getValue(params, `limit`, ""),
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      toast.error("All fields are mandatory");
    }
  };

  let country_ID =
    getValue(countryList, `length`, 0) > 0 &&
    countryList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `country_id`, "")
    );
  let state_ID =
    getValue(states, `length`, 0) > 0 &&
    states.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `state_id`, "")
    );
  let cat_ID =
    getValue(categoryOfLawList, `length`, 0) > 0 &&
    categoryOfLawList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `category_of_law_id`, "")
    );
  let leg_ID =
    getValue(legislationList, `length`, 0) > 0 &&
    legislationList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `legislation_id`, "")
    );
  let rule_ID =
    getValue(ruleList, `length`, 0) > 0 &&
    ruleList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `legislation_rule_id`, "")
    );

  const handleChangeActiveStatus = async (value: string) => {
    try {
      let resp = await vendorCheckpointBulkStatus({
        ids: selectedIDs,
        is_active: value === "active" ? true : false,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      } else {
        getData();
      }
    } catch (error) {}
  };
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };

  /* -------------------------------------------------------------------------- */
  /*                              Navigation Routes                             */
  /* -------------------------------------------------------------------------- */

  const handleNavigate = (route: string) => {
    if (route === "release-to-vendor") {
      let payload: any = {
        checkpoint_id: selectedIDs,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`/checkpoint/${route}?${queryRequest}`);
    }
  };
  const [date, setDate] = useState<Date | null>(null);
  const handleSubmitDate = () => {
    let dates = moment(date).format("YYYY-MM-DD");
    if (dates && dates !== "Invalid date") {
      let payload: any = {
        date: dates,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      toast.error("Please select date");
    }
  };

  const [dropdownOptions] = useState([
    { value: "UPDATE_VENDOR_CHECKPOINT", label: "Update Vendor Task" },
  ]);

  const handleNavigateLogs = () => {
    navigate(`/file-logs/UPDATE_VENDOR_CHECKPOINT`);
  };

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "repository_checkpoint_vendor_checkpoints"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          {getValue(selectedIDs, `length`, 0) > 0 && (
            <NavigationBar
              selectedIDs={selectedIDs}
              isMarkInactiveSectionVisible={
                getValue(props, `permissions`, []).includes("update")
                  ? true
                  : false
              }
              handleChangeActiveStatus={handleChangeActiveStatus}
              // text={"MARK INACTIVE"}
              multi={
                getValue(props, `permissions`, []).includes("update")
                  ? true
                  : false
              }
              handleRemoveNavItems={handleRemoveNavItems}
              handleNavigate={handleNavigate}
              delete={
                getValue(props, `permissions`, []).includes("update")
                  ? true
                  : false
              }
              handleDeleteFun={handleDeleteFun}
            />
          )}
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between d-none">
            <h4 className="dashbaord-wrapper__header-title">
              Vendor Checkpoints
            </h4>
            <div className="datepicker">
              {/* <DatePicker
								onChange={setDate}
								value={date}
								format="MMM yyyy"
								disableCalendar={true}
								yearAriaLabel={"yyyy"}
							/>
							<button className="header-btn" onClick={handleSubmitDate}>
								Apply
							</button> */}
              <CalenderDropdown
                value={date}
                onChange={setDate}
                handleSubmitDate={handleSubmitDate}
              />
            </div>
          </div>
          
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <MenuRepositorySvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Checkpoint
                </h6>
                <h4 className="dashbaord-wrapper__header-title">Vendor Checkpoints</h4>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <RightMenuHeaders
                // Mapped Task FH (Function Head)
                mappedTasksFH={false}

                // date range 
                dateRange={false}
                // from_date={from_date}
                // to_date={to_date}
                // handleDate={handleDate}
                // // handleCancelDate={handleCancelDate}
                // handleSubmitDate={handleSubmitDate}
                // datePickerRef={datePickerRef}
                
                monthYear={true}
                value={date}
                onChange={setDate}
                handleSubmitDate={handleSubmitDate}
                //alltime
                allTime={false}
                // handleCheckAlltime={handleCheckAlltime}

                //search
                isSearch={true}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}

                //smartFilter
                smartFilter={false}
                // handleFilter={handleFilter}

                //change owner
                changeOwner={false}
                // isOpen={isOpen}
                // handleModal={
                //   getValue(selectedIDs, `length`, 0) > 0
                //     ? handleModal
                //     : () => toast.error("Please select task")
                // }
                
                // download section
                downloadSelfComplianceReport={false}
                // handleDownloadSelfComplianceReport={
                //   handleDownloadSelfComplianceReport
                // }
                // downloadLoading={downloadLoading}

                //logs section
                // viewDownloadedSelfComplianceReports={true}
                // handleNavigateLogs={handleNavigateLogs}
                // commonUpload={
                //   getValue(props, `permissions`, []).includes("update")
                //     ? true
                //     : false
                // }
                // dropdownOptions={dropdownOptions}
                // commonViewLogs

                //Line Seperator of button
                lineSeperator={true}
                //logs section
                viewDownloadedSelfComplianceReports={true}
                handleNavigateLogs={handleNavigateLogs}
                commonUpload={
                  getValue(props, `permissions`, []).includes("update")
                    ? true
                    : false
                }
                dropdownOptions={dropdownOptions}
              />
            </div>
          </div>
          
          <div className={`main-page-layout-wrapper has-module-filter`} id={getValue(selectedIDs, `length`, 0) > 0
					? "blueNavigationVisible"
					: ""}>
            <div className="admin-wrapper position-relative">
              {/* <div className="admin-wrapper position-relative">
                <SearchHeader
                  route={"/support/details"}
                  searchInput={search_text}
                  showSearchTextbox={showSearchTextbox}
                  toggleSearch={toggleSearch}
                  toggleSearchClose={toggleSearchClose}
                  handleChangeSearch={handleChangeSearch}
                  isBulkUploadVisible={false}
                  smartFilter={false}
                  setFilterFormVisibility={() => {
                    setFilterVisibility(!isFilterVisible);
                  }}
                  isFilterVisible={isFilterVisible}
                  add={"false"}
                  search
                />
              </div> */}
              {isFilterVisible && (
                <FilterForm
                  setFilterFormVisibility={() => {
                    setFilterVisibility(!isFilterVisible);
                  }}
                  countryList={countryList}
                  states={states}
                  categoryOfLawList={categoryOfLawList}
                  legislationList={legislationList}
                  ruleList={ruleList}
                  handleChangeSelect={handleChangeSelect}
                  additionalFilter={false}
                  country_ID={country_ID}
                  state_ID={state_ID}
                  cat_ID={cat_ID}
                  leg_ID={leg_ID}
                  rule_ID={rule_ID}
                  reset={reset}
                  handleSubmitSmartFilter={handleSubmitSmartFilter}
                />
              )}
              {/* <AddFilter
        isFilterVisible={isFilterVisible}
        isFilterHeadingVisible={true}
        isFilterSubHeadingVisible={true}
        isBulkUploadVisible={true}
        addButtonLink={'/checkpoint/active-detail'}
        setFilterFormVisibility={() => {
          setFilterVisibility(!isFilterVisible);
        }}
        />
        */}

            <div>
              <ModuleFilter
              statusFilter
              filterList={filterList}
                handleChangeStatus={handleChangeStatus}
                // activeStatus
                // activationStatus={activationStatus}
              />
            </div>

              {isLoading || !props.permissionAPITriggered ? (
                <Loader />
              ) : list.length > 0 ? (
                <ScrollableReactTable
                  columns={columns}
                  data={list}
                  getTableState={getTableState}
                  rowClick={rowClick}
                  check={check}
                  selectedIDs={selectedIDs}
                  getTrProps={getTrProps}
                />
              ) : (
                <>
                  {Object.keys(params).length !== 0 ? (
                    <>
                      <CheckpointMasterNotfound />
                    </>
                  ) : (
                    <CheckpointMasterNotfound />
                  )}
                </>
              )}
            </div>
            <FooterWrapper
              list={list}
              totalCount={totalCount}
              limit={limit}
              page_no={page_no}
              handleChangePagination={handleChangePagination}
              handleChangeLimit={handleChangeLimit}
            />
          </div>
          
          <DeleteModal
            isOpen={isDelete}
            handleModal={handleDelete}
            handleSubmit={handleDeleteFunction}
            deleteValue={deleteValue}
          />
        </>
      )}
    </DashboardLayout>
  );
};
export default ClientVendorCheckpoint;
